import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async get () {
    return axios.get('/api/statuses')
      .then(r => r.data)
      .catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/statuses.js